import { FC } from "react";
import { SanityInfoPage } from "../../graphql-types";
import { cn } from "../lib/helpers";
import { desktopOnly, mobileOnly } from "../styles/utils.module.scss";
import { GlobalUrls } from "../types/globalUrls";
import BrandVisual from "./BrandVisual";
import Container from "./Container";
import Image from "./Image";
import ImageLockup from "./ImageLockup";
import InfoGraphic from "./InfoGraphic";
import * as styles from "./InfoPage.module.scss";
import PortableText from "./portableText";
import Schedule from "./Schedule";
import Tickets from "./Tickets";
import Tournaments from "./Tournaments";
import { bodyTextStyle } from "./typography.module.scss";

export interface InfoPageProps extends SanityInfoPage {
  globalUrls: GlobalUrls;
  streamathonLabel: string;
  streamathonDate: string;
  lanLabel: string;
  lanDate: string;
}

const InfoPage: FC<InfoPageProps> = ({
  leadCopy,
  _rawLeadCopy,
  graphicTitle,
  graphicLanItems,
  _rawGraphicLanItems,
  graphicStreamItems,
  _rawGraphicStreamItems,
  brandVisual,
  _rawBrandVisual,
  eventDetails,
  _rawEventDetails,
  imageLockup,
  _rawImageLockup,
  ticketsCopy,
  _rawTicketsCopy,
  ticketsCards,
  ticketsBuyCtaLabel,
  ticketsCardSpectator,
  ticketsCardPrimo,
  scheduleHidden,
  scheduleTitle,
  schedules,
  tournamentsHidden,
  tournamentsTitle,
  tournamentsFaq,
  desktopBrandImage,
  mobileBrandImage,
  closingCopyHidden,
  closingCopy,
  _rawClosingCopy,
  globalUrls,
  streamathonLabel,
  streamathonDate,
  lanLabel,
  lanDate,
  primoTicketHidden,
}) => {
  return (
    <div className={styles.root}>
      <Container>
        <div className={cn(bodyTextStyle, styles.leadCopy, styles.bodyCopy)}>
          <PortableText blocks={_rawLeadCopy || leadCopy} />
        </div>
        <InfoGraphic
          graphicTitle={graphicTitle}
          graphicLanItems={_rawGraphicLanItems || graphicLanItems}
          graphicStreamItems={_rawGraphicStreamItems || graphicStreamItems}
          streamathonLabel={streamathonLabel}
          streamathonDate={streamathonDate}
          lanLabel={lanLabel}
          lanDate={lanDate}
        />
      </Container>
      <Container noPaddingMobile>
        <BrandVisual
          content={_rawBrandVisual ? _rawBrandVisual[0] : brandVisual[0]}
        />
      </Container>

      <Container>
        <div
          id="event-details"
          className={cn(bodyTextStyle, styles.bodyCopy, styles.eventCopy)}
        >
          <PortableText blocks={_rawEventDetails || eventDetails} />
        </div>

        <ImageLockup
          className={styles.imageLockup}
          images={_rawImageLockup || imageLockup}
        />
        <Tickets
          ticketsCopy={_rawTicketsCopy || ticketsCopy}
          ticketsCards={ticketsCards}
          ticketsCardPrimo={ticketsCardPrimo}
          primoTicketHidden={primoTicketHidden}
          ticketsBuyCta={{
            label: ticketsBuyCtaLabel,
            url: globalUrls.ticketsUrl,
          }}
          ticketsCardSpectator={ticketsCardSpectator}
        />
        {!scheduleHidden && (
          <Schedule scheduleTitle={scheduleTitle} schedules={schedules} />
        )}
      </Container>
      {!tournamentsHidden && (
        <Container noPaddingMobile>
          <Tournaments
            tournamentsTitle={tournamentsTitle}
            tournamentsFaq={tournamentsFaq}
          />
        </Container>
      )}
      <Container>
        <div className={styles.brandImageWrapper}>
          <Image
            image={desktopBrandImage}
            className={cn(desktopOnly, styles.brandImage)}
            fullQuality
          />
          <Image
            image={mobileBrandImage}
            className={cn(mobileOnly, styles.brandImage)}
            fullQuality
          />
        </div>
        {!closingCopyHidden && (
          <div className={cn(bodyTextStyle, styles.closingCopy)}>
            <PortableText blocks={_rawClosingCopy || closingCopy} />
          </div>
        )}
      </Container>
    </div>
  );
};

export default InfoPage;
